function RandomFeedPanel(element) {
    this.panel = document.getElementById(element);
    this.set_items = {};
}

RandomFeedPanel.prototype = {
    constructor: RandomFeedPanel,

    getPanel: function() {
        var rendered = Mustache.render(this.panel.innerHTML, this.set_items);
        return rendered;
    },

    setRandomFeedSetItems: function() {
        var random_feed_sets = ub.funcs.getRandomFeedSets();

        var random_feed_set_items = _.filter(ub.data.random_feed_images, function(image) {
            if (image.block_pattern === ub.config.blockPattern && ub.config.option === image.block_pattern_option) {
                if (!_.contains(ub.data.sockCustomColor, image.set.toLowerCase())) {
                    return image;
                }
            }
        });

        this.set_items = {randomfeeds: random_feed_set_items};
    }
};

/**
 * static properties and functions
 */
RandomFeedPanel.STATUS_ON = "on";
RandomFeedPanel.STATUS_OFF = "off";
RandomFeedPanel.ACTIVE_RANDOM_FEED_COLOR_BUTTON = 2;
RandomFeedPanel.events = {
    is_init_events_called: 0,

    init: function() {
        if (RandomFeedPanel.events.is_init_events_called === 0) {
            $(".modifier_main_container").on("click", ".richardson-random-feed-ui .random-feed-status", RandomFeedPanel.events.onChangeStatus);
            $(".modifier_main_container").on("click", ".richardson-random-feed-ui .random-feed-layer", RandomFeedPanel.events.onChangeColorLayer);
            $(".modifier_main_container").on("click", ".richardson-random-feed-ui .random-feed-image-button", RandomFeedPanel.events.onSelectRandomFeedImage);
            $(".modifier_main_container").on("click", ".richardson-random-feed-ui .random-feed-color-list .random-feed-color-selector-button", RandomFeedPanel.events.onChangeColor);
            RandomFeedPanel.events.is_init_events_called = 1;
        }
    },

    onChangeStatus: function() {
        var status = $(this).data("status");
        var randomFeed = $(".richardson-random-feed-ui .random-feed-image-button.uk-active").data("random-feed-set");
        var randomSettings = RandomFeedPanel.getActiveRandomFeedSet(randomFeed);

        if (status === "on") {
            $(".richardson-random-feed-ui  .random-feed-modifier-container").removeClass("uk-hidden");
            RandomFeedPanel.funcs.applyRandomFeed(randomSettings.set);
            $(".richardson-random-feed-ui .random-feed-layer").first().trigger("click");
        } else {
            RandomFeedPanel.funcs.removeRandomFeed(randomSettings.set)
            $(".richardson-random-feed-ui  .random-feed-modifier-container").addClass("uk-hidden");
        }

        $(".richardson-random-feed-ui .random-feed-status.uk-active").removeClass("uk-active");
        $(this).addClass("uk-active");
    },

    onChangeColorLayer: function() {
        $(".richardson-random-feed-ui .random-feed-layer.uk-active").removeClass("uk-active");
        var layer_number = $(this).data("layer-number");
        var randomFeed = $(".richardson-random-feed-ui .random-feed-image-button.uk-active").data("random-feed-set");
        var randomSettings = ub.funcs.getRandomFeedSettingsObject(randomFeed);
        var _layer = _.find(randomSettings.layers, {layer: parseInt(layer_number)});

        // Remove Active Color
        $(".richardson-random-feed-ui .random-feed-color-list .random-feed-color-selector-button.active-random-color").find(".piping-check").remove();
        $(".richardson-random-feed-ui .random-feed-color-list .random-feed-color-selector-button.active-random-color").removeClass("active-random-color");
        var colorContainer = $(".richardson-random-feed-ui .random-feed-color-list .random-feed-color-selector-button[data-color-code='" +  _layer.colorCode + "']");

        // Create check
        var html;
        html = '<div class="cp-check-background piping-check"><span class="fa fa-check fa-1x cp-piping-check-medium"></span></div>';

        if (_layer.colorCode === 'W'
            || _layer.colorCode === 'Y'
            || _layer.colorCode === 'CR'
            || _layer.colorCode === 'S'
            || _layer.colorCode === 'PK'
            || _layer.colorCode === 'OP'
            || _layer.colorCode === 'SG'
            || _layer.colorCode === 'none'
        ) {
            html = '<div class="cp-check-background piping-check"><span class="fa fa-check fa-1x cp-piping-check-medium cp-fc-black"></span></div>';
        }

        colorContainer.html("");
        colorContainer.html(html);
        colorContainer.addClass("active-random-color");
        $(this).addClass("uk-active");

        RichardsonOrderEditor.statusChecker(RandomFeedPanel.disableFunctionality, 500);
    },

    onSelectRandomFeedImage: function() {
        $(".richardson-random-feed-ui .random-feed-image-button.uk-active").removeClass("uk-active");
        $(this).addClass("uk-active");

        var colors = ColorPalette.funcs.getConfigurationPerTab("randomFeed");
        var _template = document.getElementById("random-feeds-settings-modifier").innerHTML;
        var _markup = Mustache.render(_template, {
            colors: colors
        });

        var randomFeed = $(this).data("random-feed-set");
        var randomSettings = ub.funcs.getRandomFeedSettingsObject(randomFeed);

        $(".richardson-random-feed-ui .random-feed-settings-container").html("");
        $(".richardson-random-feed-ui .random-feed-settings-container").html(_markup);

        if (typeof randomSettings.enabled !== undefined) {
            if (randomSettings.enabled === 1) {
                $(".richardson-random-feed-ui .random-feed-status[data-status='on']").trigger("click");
                $(".richardson-random-feed-ui .random-feed-layer").first().trigger("click");
            } else {
                $(".richardson-random-feed-ui .random-feed-status[data-status='off']").trigger("click");
            }
        }

        RichardsonOrderEditor.statusChecker(RandomFeedPanel.disableFunctionality, 250);
    },

    onChangeColor: function() {
        $(".richardson-random-feed-ui .random-feed-color-list .random-feed-color-selector-button.active-random-color").find(".piping-check").remove();
        $(".richardson-random-feed-ui .random-feed-color-list .random-feed-color-selector-button.active-random-color").removeClass("active-random-color");

        var randomFeed = $(".richardson-random-feed-ui .random-feed-image-button.uk-active").data("random-feed-set");
        var _layer_no   = $(".richardson-random-feed-ui .random-feed-layer.uk-active").data('layer-number');
        var _color_code = $(this).data('color-code');
        var _colorObj   = ub.funcs.getColorByColorCode(_color_code);

        $(this).html('<div class="cp-check-background piping-check"><span class="fa fa-check fa-1x cp-piping-check-medium"></span></div>');

        if (_color_code === 'W'
            || _color_code === 'Y'
            || _color_code === 'CR'
            || _color_code === 'S'
            || _color_code === 'PK'
            || _color_code === 'OP'
            || _color_code === 'SG'
            || _color_code === 'none'
        ) {
            $(this).html('<div class="cp-check-background piping-check"><span class="fa fa-check fa-1x cp-piping-check-medium cp-fc-black"></span></div>');
        }

        RandomFeedPanel.funcs.changeRandomFeedColor(_colorObj, _layer_no, randomFeed);

        $(this).addClass('active-random-color');
    },

    onColorItemClick: function() {
        if ($(this).hasClass('turnOff')) {
            return;
        }

        var random_feed_item_el = $(this).closest('.random-feed-item');
        var random_feed_type = random_feed_item_el.data('random-feed-type');

        var _layer_no   = $(this).data('layer-no');
        var _color_code = $(this).data('color-code');
        var _layer_name = $(this).data('layer-name');
        var _temp       = $(this).data('temp');
        var _colorObj   = ub.funcs.getColorByColorCode(_color_code);

        var active_random_feed = RandomFeedPanel.getActiveRandomFeedSet(random_feed_type);
        var randomFeedObject = _.find(ub.data.randomFeeds, {name: active_random_feed.name});
        var randomFeedSettingsObject = ub.funcs.getRandomFeedSettingsObject(active_random_feed.set);

        var matchingName = "";
        var matchingRandomFeedObject;
        var matchingRandomFeedSettingsObject;

        if (randomFeedObject.name.indexOf('Left') > -1) {
            matchingName = ub.funcs.getMatchingSide(randomFeedObject.name);
            matchingRandomFeedObject = _.find(ub.data.randomFeeds, {name: matchingName});
        }

        if (randomFeedObject.name.indexOf('Right') > -1) {
            matchingName = ub.funcs.getMatchingSide(randomFeedObject.name);
            matchingRandomFeedObject = _.find(ub.data.randomFeeds, {name: matchingName});
        }

        if (typeof matchingRandomFeedObject !== 'undefined') {
            matchingRandomFeedSettingsObject = ub.funcs.getRandomFeedSettingsObject(matchingRandomFeedObject.set);
            ub.funcs.changeRandomFeedSize(matchingRandomFeedSettingsObject, matchingRandomFeedObject, active_random_feed.size);
        }

        ub.funcs.changeRandomFeedColor(_colorObj, _layer_no, randomFeedObject);
        RandomFeedPanel.changeActiveColor(_layer_no, _color_code, _colorObj, random_feed_item_el);

        var _layer = _.find(randomFeedSettingsObject.layers, {layer: parseInt(_layer_no)});

        if (typeof _layer !== "undefined") {

            _layer.colorCode = _color_code;
            _layer.colorObj = _colorObj;
        
        }
        
        if (typeof matchingRandomFeedObject !== "undefined") {

            ub.funcs.changeRandomFeedColor(_colorObj, _layer_no, matchingRandomFeedObject);

            var _matchingLayer         = _.find(matchingRandomFeedSettingsObject.layers, {layer: parseInt(_layer_no)});

            if (typeof _matchingLayer !== "undefined") {

                _matchingLayer.colorCode   = _color_code;
                _matchingLayer.colorObj    = _colorObj;

            }
            
        }
    }
};

RandomFeedPanel.funcs = {
    applyRandomFeed: function(randomFeedType) {
        var colors = ColorPalette.funcs.getConfigurationPerTab("randomFeed");
        var activeRandomFeed = RandomFeedPanel.getActiveRandomFeedSet(randomFeedType);
        var randomFeedObject = _.find(ub.data.randomFeeds, {name: activeRandomFeed.name});
        var randomFeedSettingsObject = ub.funcs.getRandomFeedSettingsObject(activeRandomFeed.set);
        // Matching Part
        var matchingName = "";
        var matchingRandomFeedObject;
        var matchingRandomFeedSettingsObject;
        
        if (randomFeedObject.name.indexOf('Left') > -1) {
            matchingName = ub.funcs.getMatchingSide(randomFeedObject.name);
            matchingRandomFeedObject = _.find(ub.data.randomFeeds, {name: matchingName});
        }
        
        if (randomFeedObject.name.indexOf('Right') > -1) {
            matchingName = ub.funcs.getMatchingSide(randomFeedObject.name);
            matchingRandomFeedObject = _.find(ub.data.randomFeeds, {name: matchingName});
        }

        if (typeof matchingRandomFeedObject !== 'undefined') {
            matchingRandomFeedSettingsObject = ub.funcs.getRandomFeedSettingsObject(matchingRandomFeedObject.set);
            ub.funcs.changeRandomFeedSize(matchingRandomFeedSettingsObject, matchingRandomFeedObject, active_random_feed.size);
        }

        $(".richardson-random-feed-ui .random-feed-image-button[data-random-feed-set='"+ randomFeedType +"']").addClass("selected");

        randomFeedSettingsObject.enabled = 1;

        ub.funcs.initRandomFeedColors(randomFeedObject, colors[0]);
        ub.funcs.renderRandomFeed(randomFeedObject, RandomFeedPanel.ACTIVE_RANDOM_FEED_COLOR_BUTTON);
    }, 

    removeRandomFeed: function (randomFeed) {
        ub.funcs.removeRandomFeed(randomFeed);

        if (randomFeed.indexOf('Left') === 0) {
            var matchingSide = ub.funcs.getMatchingSide(randomFeed);
            ub.funcs.removeRandomFeed(matchingSide);
        }

        $(".richardson-random-feed-ui .random-feed-image-button[data-random-feed-set='"+ randomFeed +"']").removeClass("selected");
    },

    changeRandomFeedColor: function(_colorObj, _layer_no, randomFeed) {
        var active_random_feed = RandomFeedPanel.getActiveRandomFeedSet(randomFeed);
        var randomFeedObject = _.find(ub.data.randomFeeds, {name: active_random_feed.name});
        var randomSettings = ub.funcs.getRandomFeedSettingsObject(randomFeed);

        ub.funcs.changeRandomFeedColor(_colorObj, _layer_no, randomFeedObject);
        var _layer = _.find(randomSettings.layers, {layer: parseInt(_layer_no)});

        if (typeof _layer !== "undefined") {
            _layer.colorCode = _colorObj.color_code;
            _layer.colorObj = _colorObj;
        }

        var matchingName = "";
        var matchingRandomFeedObject;
        var matchingRandomFeedSettingsObject;

        if (randomFeedObject.name.indexOf('Left') > -1) {
            matchingName = ub.funcs.getMatchingSide(randomFeedObject.name);
            matchingRandomFeedObject = _.find(ub.data.randomFeeds, {name: matchingName});
        }
        
        if (randomFeedObject.name.indexOf('Right') > -1) {
            matchingName = ub.funcs.getMatchingSide(randomFeedObject.name);
            matchingRandomFeedObject = _.find(ub.data.randomFeeds, {name: matchingName});
        }

        if (typeof matchingRandomFeedObject !== 'undefined') {
            matchingRandomFeedSettingsObject = ub.funcs.getRandomFeedSettingsObject(matchingRandomFeedObject.set);
            ub.funcs.changeRandomFeedSize(matchingRandomFeedSettingsObject, matchingRandomFeedObject, active_random_feed.size);
        }

        if (typeof matchingRandomFeedObject !== "undefined") {

            ub.funcs.changeRandomFeedColor(_colorObj, _layer_no, matchingRandomFeedObject);
            var _matchingLayer         = _.find(matchingRandomFeedSettingsObject.layers, {layer: parseInt(_layer_no)});

            if (typeof _matchingLayer !== "undefined") {
                _matchingLayer.colorCode   = _colorObj.color_code;
                _matchingLayer.colorObj    = _colorObj;
            }
        }
    }
};

RandomFeedPanel.getActiveRandomFeedSet = function(random_feed_type) {
    var random_feed_set = random_feed_type;
    var active_random_feed_set = ub.current_material.settings.randomFeeds[random_feed_type];

    if (active_random_feed_set === "undefined") {
        active_random_feed_set    = _.first(random_feed_set);
    } else {
        random_feed_set          = ub.funcs.getRandomFeedSet(random_feed_type);
        active_random_feed_set    = _.first(random_feed_set);
    }

    return active_random_feed_set;
};

RandomFeedPanel.setInitialState = function() {
    var randomFeedSets = ub.funcs.getRandomFeedSets();

    _.map(randomFeedSets, function(randomFeed) {
        var randomFeedSettingsObject = ub.funcs.getRandomFeedSettingsObject(randomFeed);
        if (typeof randomFeedSettingsObject.enabled !== "undefined") {
            if (randomFeedSettingsObject.enabled === 1) {
                $(".richardson-random-feed-ui .random-feed-image-button[data-random-feed-set='"+ randomFeed +"']").addClass("selected");
            } 
        }
    });
};

RandomFeedPanel.disableFunctionality = function() {
    var parent = $(".richardson-random-feed-ui");
    var disableClass = "uk-disabled";
    $(".random-feed-status", parent).addClass(disableClass);
    $(".random-feed-color-list", parent).addClass(disableClass);
}